import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { DeliveryDashboardComponent } from './components/delivery-dashboard/delivery-dashboard.component';
import { authGuard } from './services/auth.guard';
import { TokenVerificationComponent } from './components/token-verification/token-verification.component';
import {ProjectNavBarComponent} from "./components/project-nav-bar/project-nav-bar.component";
import {RiderTripsComponent} from "./components/rider-trips/rider-trips.component";
import {FacilityIncentivesComponent} from "./components/facility-incentives/facility-incentives.component";

const routes: Routes = [

  { path: '', redirectTo: 'verify', pathMatch: 'full' },
  { path: 'verify.html', component: TokenVerificationComponent },
  { path: 'verify', component: TokenVerificationComponent },
  {
    path: '',
    component: ProjectNavBarComponent,
    canActivateChild: [authGuard],
    children: [
      { path: 'deliveries', component: DeliveryDashboardComponent, canActivate: [authGuard] },
      {path: 'rider-trips', component: RiderTripsComponent, canActivate: [authGuard] },
      {path: 'facility-incentives', component: FacilityIncentivesComponent, canActivate: [authGuard]  },
    ]
  },

  //fallback
  {path: '**', redirectTo: 'verify', pathMatch: 'full' },
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule {}
